<template>
  <tr id="searchTableRow">
    <td id="searchTableRow-Data">
      <router-link v-bind:to="caseUrl" :id="'searchTableRow-dataLink-'+caseObj.policycaseHeaderId">
        {{ caseObj.policycaseHeaderId }}
      </router-link>
    </td>
    <td>
      <h5><span class="badge badge-light">
        <i v-bind:class="badge"></i>
        {{ getDescriptionByName(caseObj.productName) }}
      </span></h5>
    </td>
    <td v-if="isAllCases">{{caseObj.status | translate('status') }}</td>
    <td v-if="isArchivedCases">{{ caseObj.selectedInsurer | translate }}</td>
    <td>{{caseObj.batchID}}</td>
    <td>
      <ul class="list-group">
        <li class="list-group-item"
          v-for="cover in caseObj.requestedCovers">
          <em>{{ cover | translate('cover') }}</em>
        </li>
      </ul>
    </td>
    <td>
      <ul class="list-group">
        <!-- validations on requested -->
        <li
          v-for="validation in caseObj.requestValidations"
          class="justify-between-content list-group-item">
          <span class="badge" :class="{
            'badge-secondary': validation.level === 'AUDIT',
            'badge-info': validation.level === 'INFO',
            'badge-warning': validation.level === 'WARN',
            'badge-danger': validation.level === 'ERROR'
           }">{{ validation.level }}</span>
          {{ validation.description }}
        </li>
      </ul>
      <ul class="list-group" >
        <!-- response validations -->
        <li
          v-for="validation in caseObj.responseValidations"
          class="justify-between-content list-group-item">
          <span>
            <span class="badge badge-light">{{ validation.insurer }}</span>
            <span class="badge" :class="{
              'badge-secondary': validation.level === 'AUDIT',
              'badge-info': validation.level === 'INFO',
              'badge-warning': validation.level === 'WARN',
              'badge-danger': validation.level === 'ERROR'
            }">{{ validation.level }}</span>
          </span>
          {{ validation.description }}
        </li>
      </ul>
    </td>
    <td v-if="isClosedCases">{{ caseObj.statusReason }}</td>
  </tr>
</template>
<script>
export default {
  props: ['status', 'caseObj', 'productLines'],
  computed: {
    isAllCases: function() {
      return this.status === 'all';
    },
    isOpenCases: function() {
      return this.status === 'open';
    },
    isArchivedCases: function() {
      return this.status === 'archived';
    },
    isClosedCases: function() {
      return this.status === 'closed';
    },
    caseUrl: function() {
      return '/case/' + this.caseObj.policycaseHeaderId;
    },
    badge: function() {
      let classStr = 'fa ';

      switch (this.caseObj.productLine) {
        case 'HOUSECONTENT':
          classStr += 'fa-home';
          break;
        case 'HOUSEFIRE':
          classStr += 'fa-fire-extinguisher';
          break;
        case 'LIABILITY':
          classStr += 'fa-user';
          break;
        case 'PASSENGERCAR':
          classStr += 'fa-car';
          break;
        case 'HEARINGAID':
          classStr += 'fa-deaf';
          break;
        case 'TRAVEL':
          classStr += 'fa-suitcase';
      };
      return classStr;
    }

  },
  methods: {
    getDescriptionByName(name) {
      for (let item of this.productLines) {
        if (item.name === name) {
          return item.description;
        }
      }
      return '-';
    }
  }
}
</script>
<style scoped>
.list-group-item {
  border-color: #fff0;
  background: #fff0;
  padding: 0px 0px 5px 0px;
}
.list-group {
  background: #fff0;
  border-color: #fff0;
}
</style>



// WEBPACK FOOTER //
// src/components/search/SearchTableRow.vue